"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCodeImg = getCodeImg;
exports.getInfo = getInfo;
exports.login = login;
exports.logout = logout;
exports.telLogin = telLogin;
exports.tokenLogin = tokenLogin;
var _request = _interopRequireDefault(require("@/utils/request"));
var _cloud = require("@/utils/cloud");
// 登录方法
function login(username, password, code, uuid, tenantId) {
  var data = {
    username: username,
    password: password,
    code: code,
    uuid: uuid,
    tenantId: tenantId
  };
  return (0, _request.default)({
    url: _cloud.urls.user + '/login',
    method: 'post',
    data: data
  });
}

// 获取用户详细信息
function getInfo() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/getInfo',
    method: 'get'
  });
}

// 退出方法
function logout() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/logout',
    method: 'post'
  });
}

// 获取验证码
function getCodeImg() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/captchaImage',
    method: 'get'
  });
}

// 短信登录方法
function telLogin(username, password, code, uuid, telephone, tenantId) {
  var data = {
    username: username,
    password: password,
    code: code,
    uuid: uuid,
    telephone: telephone,
    tenantId: tenantId
  };
  return (0, _request.default)({
    url: _cloud.urls.user + '/sms/login',
    method: 'post',
    data: data
  });
}
// 芯盾单点登录
function tokenLogin(code) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/tokenLogin/' + code,
    method: 'get'
  });
}